import React, { Fragment } from 'react';
import { useAppState, getBackgroundImg, getUploadedImagePath, MarkupRender } from '@nutastic/nutastic-react-app';
import Fade from 'react-reveal/Fade';
import Gallery from '../Gallery';
import moveIntoView from '../../utils/moveIntoView';
import ResourcesBox from '../ResourcesBox';

const HomePage = () => {
    const {
        gallery = [],
        page: {
            field_1: welcomeSubtitle,
            field_2: welcomeScript,
            field_3: weddingInfoTitle,
            content: weddingInfoContent,
            field_4: weddingInfoFooter,
            field_6: connectTitle,
            field_8: connectText,
            field_9: footerText,
            image_1: pageImage
        }
    } = useAppState();
    const componentClass = 'home-page';

    return <Fragment>
        <section className={`${componentClass}__banner`} style={getBackgroundImg(getUploadedImagePath(pageImage))}>
            <div className="overlay" />
            <div className="container h-100">
                <div className={`${componentClass}__date animated fadeInRight delay-1s`}>6.12.22</div>
                <div className={`${componentClass}__banner-content animated fadeInUp delay-1s`}>
                    <h5>{ welcomeSubtitle }</h5>
                    <div className="script-text">{ welcomeScript }</div>
                    <i className="ion-ios-arrow-down animated fadeInUp" onClick={ () => moveIntoView('wedding-section') } />
                </div>
            </div>
        </section>

        <section className={`${componentClass}__wedding page-section page-section--padded`} id="wedding-section">
            <Fade top fraction={1} wait={500}><div className="top-flowers" /></Fade>
            <div className="container">
                <div className="wedding-info">
                    <h5 className="mb-2">I have found the one whom my soul loves</h5>
                    <h5 className="mb-5">Song of Solomon 3:4</h5>
                    <h1>{ weddingInfoTitle }</h1>
                    <div className="wedding-info__heart">
                        <i className="ion-ios-heart" />
                    </div>
                    <MarkupRender className="info" content={ weddingInfoContent } />
                    <div className="mt-5 mb-5 wedding-info__address" id="reservation-section">
                        <h5>June 12, 2022 | 6:00PM</h5>
                        <h5>The Foxglove</h5>
                        <h5>54 Atlanta St. SE Suite B.</h5>
                        <h5>Marietta, GA 30060</h5>
                    </div>
                    <small>{ weddingInfoFooter }</small>
                </div>
            </div>
            <Fade bottom><div className="bottom-flowers" /></Fade>
        </section>

        <div className={`${componentClass}__reservation page-section page-section--padded background-light`}>
            <div className="container">
                <ResourcesBox />
            </div>
            <div className="container mt-5" id="gallery-section">
                <Gallery images={gallery}/>
                <div className="clear clear-xxl" />
                <div className="connect-spot">
                    <h5>Cori & Rocko | <span className="color-pink">#BECOMINGBOLTS</span></h5>
                    <h2 className="mt-4 mb-4">{ connectTitle }</h2>
                    <MarkupRender className="info" content={ connectText } />
                    <Fade wait={1000} right><h1 className="script-text">{ footerText }</h1></Fade>
                </div>
            </div>
        </div>
    </Fragment>;
};

export default HomePage;
